// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"186775a4","299":"e525fe26","453":"b53bba07","667":"e5bbfb50","859":"1f8e6a8e","977":"6dea786b"}[chunkId] + ".chunk.js";
};